import React from "react";
import { ChatLogContext } from "./chat-log-context";

export function useChatLog() {
  const context = React.useContext(ChatLogContext);
  if (!context) {
    throw new Error("useChatLog must be used within a ChatLogProvider");
  }
  return context;
}
